<template>
  <div class="registrationAgreement">
    <h1 class="tCenter">
      智筑通注册协议
    </h1>
    <p>
      【审慎阅读】您在申请注册流程中点击同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用及解决争议条款。如您对本协议有任何疑问，可向智筑通客服咨询。
    </p>
    <p>
      【签约动作】当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与智筑通达成一致，成为智筑通平台“用户”。阅读本协议过程中，如您不同意本协议或其中任何条款约定，您应立即停止注册程序。
    </p>
    <h1>第一条 定义</h1>
    <p>
      <b>1.1智筑通：</b>系指上海西兰蒂亚科技有限公司所有并经营的，网址为http://www.aiot369.com/的装配式钢结构产业服务平台。
    </p>
    <p>
      <b>1.2智筑通服务：</b>系指上海西兰蒂亚科技有限公司通过互联网，以包含智筑通、客户端等在内的各种方式（包括未来技术发展出现的新的服务方式）向您提供的各项服务。
    </p>
    <p>
      <b>1.3您/用户：</b>指符合智筑通平台注册要求且注册为会员的法人或其他组织以及受该等法人或其他组织授权办理注册、开户等相关事宜的自然人。
    </p>

    <h1>第二条 协议</h1>
    <p>
      <b>2.1签约主体：</b>本协议由智筑通平台经营者（上海西兰蒂亚科技有限公司）与用户共同缔结，本协议对您与智筑通平台经营者均具有法律效力。
    </p>
    <p>
      <b>2.2协议完整性：</b>本协议内容包括本协议正文及智筑通平台已经发布或将来可能发布的各类规则，如交易规则、指南等。所有规则为本协议不可分割的一部分，与本协议正文具有同等法律效力。
    </p>
    <p>
      <b>2.3协议变更：</b>智筑通平台有权根据业务需要酌情修订本协议，如本协议有任何变更，智筑通平台将在网站上刊载公告，不再单独另行通知予您。经修订的协议一经在智筑通公布，即产生效力。如您不同意相关修订，请您立即停止使用智筑通平台服务。如您继续使用智筑通平台服务，则将视为您已接受经修订的协议，当您与智筑通平台发生争议时，应以最新的协议为准。
    </p>
    <p>
      <b>2.4接受：</b>以任何方式进入智筑通并使用智筑通平台服务即表示您已充分阅读、理解并同意接受本协议的条款和条件(以下合称“条款”)。
    </p>

    <h1>第三条 风险提示</h1>
    <p>
      <b>3.1风险承担：</b>使用智筑通的相关服务时将存在（但不限于）以下风险，您将承担由此导致的损失：
    </p>
    <p>
      3.1.1
      由于智筑通无法控制和不可预测原因，如地震、水灾、火灾等不可抗力，系统故障、设备故障、通讯故障、电力故障、网络故障及其它因素,可能导致系统非正常运行甚至瘫痪,使您的交易指令或数据信息出现延迟、中断、数据错误、指令无法成交等情况；
    </p>
    <p>
      3.1.2
      由于线上交易、清算交收、行情揭示、资金划付是通过电子通讯技术和电脑技术来实现的，这些技术存在着被网络黑客和计算机病毒攻击的可能，因此导致的系统故障，可能使交易无法进行及行情信息出现错误或延迟，或资金不能及时到账，给您带来的损失；
    </p>
    <p>
      3.1.3互联网上的数据传输可能因通信繁忙等原因出现延迟、中断、数据错误或不完全，从而使网上数据传输或交易出现延迟、中断、错误等；
    </p>
    <p>3.1.4 如果您缺乏网上交易经验，可能因操作不当造成交易失败或交易失误；</p>
    <p>
      3.1.5 您应注意到，与以欺诈手段行事的人进行交易的风险是客观存在的；
      智筑通希望您在使用智筑通平台服务时，小心谨慎并运用常识；
    </p>
    <p>
      <b>3.2 不完全揭示：</b>上述风险提示可能无法完全揭示接受智筑通服务时可能面临的所有风险，您在开户之前，应全面了解智筑通公布的交易规则及其他文件，对您的经济承受能力和风险控制能力作出相应的判断，在此基础上确定是否接受智筑通的服务。
    </p>
    <p>
      <b>3.3 商贸信息：</b>智筑通不能控制或保证智筑通平台上商贸信息的真实性、合法性、准确性，亦不能控制或保证交易所涉及的物品的质量、安全或合法性。
    </p>
    <p>
      <b>3.4 履行能力：</b>智筑通不能也不会控制或保证交易各方履行各项义务的能力。倘若您与一名或一名以上用户，或与您通过智筑通获取服务的第三方供应商发生争议，您在此确认，免除智筑通(及智筑通代理人和雇员)因该等争议而引起的，或在任何方面与该等争议有关的不同种类和性质的任何(实际和后果性的)权利主张、要求和损害赔偿等方面的责任。
    </p>

    <h1>第四条 账户和安全</h1>
    <p>
      <b>4.1 用户资格：</b>您确认，在您开始注册程序使用智筑通服务前，您应当是具备完全民事权利能力并与所从事的民事行为相适应的自然人、法人或其他组织。否则您将承担一切后果，且智筑通有权注销（永久冻结）您的账户，并向您索偿。如您代表一家公司或其他法律主体在智筑通上注册登记，则您声明和保证，您有权使该公司或该法律主体受本协议“条款”的约束。
    </p>
    <p>
      <b>4.2 会员账户：</b>
    </p>
    <p>
      4.2.1
      当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，您可获得智筑通账户并成为智筑通手机注册会员。一个手机号仅允许注册一个账户。如有证据证明或智筑通有理由相信您存在不当注册或不当使用多个智筑通账户的情形，智筑通可采取冻结或关闭账户、取消订单、拒绝提供服务等措施，如给智筑通及相关方造成损失的，您还应当承担赔偿责任。
    </p>
    <p>
      4.2.2
      您在智筑通注册会员账户时应按照法律法规及注册页面提示填写信息和提交相关资料（以下简称“您的资料”），
      智筑通如有合理理由怀疑您提供的资料错误、不实、过时或不完整的，有权向您发出询问及/或要求改正的通知，并有权直接做出删除相应资料的处理，直至中止、终止对您提供部分或全部服务，由此产生的一切损失由您个人承担，智筑通对此不承担任何责任。
    </p>
    <p>
      4.2.3
      您特此保证，您对提交给智筑通的“您的资料”拥有全部权利，您有义务保持您提供信息的真实性及有效性。您应当及时更新您的资料，在法律有明确规定要求智筑通必须对部分用户的信息进行核实的情况下，智筑通依法不时地对您的信息进行检查核实，您应当配合提供最新、真实、完整、有效的信息。您确认，智筑通前述核实仅为一项权利，并非智筑通应当履行的义务，智筑通没有义务去认定或决定您提交给智筑通的资料哪些属于真实有效，哪些是应当受到保护的，对享有“服务”的其他用户使用“您的资料”，智筑通也不必负责。
    </p>
    <p>
      <b>4.3 资金账户：</b>
    </p>
    <p>
      4.3.1
      您可通过智筑通向与智筑通合作的银行申请资金账户（具体按智筑通合作银行的要求办理），该资金账户便于您在智筑通交易时资金划转。您授权智筑通将您的指令传达给银行，除非得到您的同意，智筑通不会干涉您的指令和资金划转行为，一切法律后果由您自行承担，指令的执行结果取决于银行，智筑通不对此负责。
    </p>
    <p>
      4.3.2
      您应当对您的资金账户密码和操作安全负责，妥善保管资金账户、密码、U盾等资料和物品，因此造成的一切损失由您自行承担，智筑通对此不负责。
    </p>
    <p>
      4.3.3
      根据交易规则，当您支付或接受货款时，为了保证交易的安全和便利，货款会在一定时间内被智筑通冻结，直到交易完成或其它解冻事由出现。您对此完全知晓并同意。
    </p>
    <p>
      4.3.4货款等款项留存于您的资金账户期间，智筑通及智筑通合作银行将不向您支付任何利息。您对此完全知晓并同意。
    </p>
    <p>
      4.3.5
      当您与交易对手发生纠纷时，您同意智筑通冻结相关保证金货款，直到您与交易对手双方达成一致意见或智筑通收到相关司法裁判文书。
    </p>
    <p>
      <b>4.4 账户安全：</b>
    </p>
    <p>
      4.4.1
      您的账户系由您自行设置（包括但不限于账户名、昵称、绑定人手机号码、密码等）并由您保管，您应对账户项下的所有行为及结果（包括但不限于信息披露、发布信息、网上点击同意或提交各类规则协议、签署交易合同、金钱支付及向智筑通发出各项指令）负责。
    </p>
    <p>
      4.4.2
      智筑通任何时候均不会主动要求您提供您的账户密码，因此建议您务必保管好您的账户密码，并确保您在每个上网时段结束时退出登录并以正确步骤离开智筑通。若账户密码因您泄露或因您遭受他人攻击、诈骗等行为而产生损失及后果，智筑通并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。
    </p>
    <p>
      4.4.3
      您同意，如发现任何人未经授权使用您的账户，或发生违反保密规定的任何其他情况，您会立即通知智筑通，并授权智筑通将该信息同步给您申请资金账户的合作银行，您理解智筑通对您的任何请求采取行动均需要合理时间，且智筑通应您请求而采取的行动可能无法避免或阻止侵害后果的形成或扩大，除智筑通应承担的法定责任外，智筑通不承担责任。
    </p>
    <p>
      <b>4.5 账户转让：</b>因您的账户关联您的信用信息，仅当有法律明文规定、司法裁定或经智筑通同意，并符合智筑通平台规则规定的账户转让流程的情况下，您可进行账户转让。您的账户一经转让，该账户项下权利义务一并转移。除此外，您的账户不得以任何方式转让，否则智筑通有权追究您的违约责任，且由此产生的一切责任均由您承担。
    </p>
    <p>
      <b>4.6账户注销：</b>若您不再继续在智筑通平台参与交易，应申请办理账户注销手续。未办理注销手续的，您应对您账户发生的所有行为承担全部责任。
    </p>

    <h1>第五条 服务终止</h1>
    <p>
      <b>5.1 未收费终止：</b>您同意，在智筑通未向您收费的情况下，智筑通可自行全权决定以任何理由终止您账户的使用，并可进一步使您的账户无效，或注销您的账户以及在您的账户内的所有相关资料和档案。前述智筑通服务终止后，智筑通没有义务为您保留原账户中或与之相关的任何信息，或转发任何未曾阅读或发送的信息给您或第三方。您同意，智筑通不会就终止向您提供智筑通平台服务而对您或任何第三方承担任何责任。
    </p>
    <p>
      <b>5.2 已收费终止：</b>您同意在智筑通向您收费的情况下，如智筑通基于合理的怀疑认为您有违约情形亦可实施上述终止智筑通平台服务的行为。
    </p>
    <p>
      <b>5.3 注销账户：</b>您有权向智筑通申请终止向您提供智筑通平台服务并注销您的账户，经智筑通审核同意的，智筑通将注销您的账户。另外，在适用5.1条及5.2条规定，智筑通终止向您提供智筑通服务的情形下，智筑通也有权注销您的账户。您的账户被注销后，在您履行完毕所有对智筑通义务时，您与智筑通基于本协议的合同关系即终止，除智筑通的法定义务外，智筑通没有义务为您保留或向您披露您账户中的任何信息，也没有义务向您或第三方转发任何您未曾阅读或发送过的信息。
    </p>
    <p>
      <b>5.4 您理解并同意，您与智筑通的合同关系终止后：</b>
    </p>
    <p>5.4.1 智筑通有权保留您的注册数据及以前的交易行为记录。</p>
    <p>
      5.4.2
      若您在注销前在智筑通平台上存在违法行为或违反本协议和/或规则的行为的，智筑通仍可依据本协议向您主张权利。
    </p>
    <p>
      5.4.3
      您在使用智筑通平台服务期间因使用智筑通服务与其他用户之间发生的关系，不因本协议的终止而终止，其他用户仍有权向您主张权利，您应继续按您的承诺履行义务。
    </p>

    <h1>第六条 用户的权利和义务</h1>
    <p>
      <b>6.1 用户名及密码：</b>用户有权拥有自己在智筑通的用户名及密码，并有权使用自己的用户名及密码随时登录智筑通。除本协议另有约定外，用户不得以任何形式擅自转让或授权他人使用自己智筑通的用户名和密码。
    </p>
    <p>
      <b>6.2 使用智筑通平台功能：</b>通过智筑通平台，您可在智筑通上发布装配式钢结构相关商品交易信息、查询商品和服务信息等等，平台的其他服务根据您的账户权限会逐个对账户开放。
    </p>
    <p>
      <b>6.3 信息发布要求：</b>用户发布在智筑通平台上的信息必须真实。您应当确保您所发布的信息不包含以下内容：
    </p>
    <p>（1） 违反国家法律法规禁止性规定的；</p>
    <p>（2） 欺诈、虚假、不准确或存在误导性的；</p>
    <p>（3） 侵犯他人知识产权或涉及第三方商业秘密及其他专有权利的；</p>
    <p>
      （4）
      存在可能破坏、篡改、删除、影响智筑通平台任何系统正常运行或未经授权秘密获取智筑通平台及其他用户的数据、个人资料的病毒、木马等恶意软件、程序代码的。
    </p>
    <p>
      <b>6.4 信息审核和使用：</b>用户同意智筑通平台可以自行或通过合作的第三方机构对用户提交或智筑通平台收集的用户信息（包括但不限于用户的身份信息、财务信息、工作信息、经营信息等）进行核实，并对获得的核实结果根据相关法律法规、本协议及有关文件进行查看、使用和留存等操作。
    </p>
    <p>
      <b>6.5调解纠纷：</b>用户在智筑通上交易过程中若与其他用户因交易等行为产生纠纷，可请求智筑通从中予以协调。
    </p>
    <p>
      <b>6.6 禁止恶意评价：</b>用户不得在智筑通上恶意评价其他用户，或采取不正当手段提高自身的信用或降低其他用户的信用。
    </p>
    <p>
      <b>6.7 用户承诺：</b>用户承诺自己在使用智筑通时实施的所有行为均遵守国家法律、法规和智筑通相关规定以及各种社会公共利益或公共道德。如有违反导致任何法律后果的发生，用户应自行承担全部法律责任，智筑通因此而遭受损失的，用户应承担全部法律责任。
    </p>

    <h1>第七条 智筑通的权利和义务</h1>
    <p>
      <b>7.1 收费：</b>智筑通保留向您收费的权利，在智筑通发布收费规则后，如您不同意，您应立即退出智筑通的相关服务。您在使用智筑通服务过程中，按法律规定应承担的税赋义务均由您自行承担。
    </p>
    <p>
      <b>7.2 技术支持：</b>智筑通致力于在现有技术上维护整个交易平台的正常运行，并努力提升和改进技术，使用户网上交易活动得以顺利进行，但如同3.1条和9.1.2条所规定，智筑通对应由您承担风险的技术问题不承担责任。
    </p>
    <p>
      <b>7.3 信息审查：</b>存在下列情形之一，智筑通在提供服务的过程中有权根据不同情况选择保留或删除相关信息或继续、停止对该用户提供服务，并追究相关法律责任：
    </p>
    <p>
      （1）
      用户或其他第三方通知智筑通，认为某个具体用户或具体交易事项可能存在重大问题；
    </p>
    <p>
      （2）
      用户或其他第三方向智筑通告知交易平台上有违法或不当行为的，智筑通以普通非专业交易者的知识水平标准对相关内容进行判别，可以明显认为这些内容或行为具有违法或不当性质的；
    </p>
    <p>
      （3） 智筑通认为用户存在其他违法或有违诚信等其他不当行为的。
      用户确认，上述智筑通的审查和决定仅系智筑通的一项权利而非智筑通的义务。
    </p>
    <p>
      <b>7.4 调解纠纷：</b>用户在智筑通交易过程中如与其他用户因交易产生纠纷，请求智筑通从中予以调处，经智筑通审核后，智筑通有权通过电子邮件等联系纠纷双方了解情况，并将所了解的情况通过电子邮件等互相通知对方。因智筑通非司法机构，您完全理解并承认，智筑通对证据的鉴别能力及对纠纷的处理能力有限，受理用户间的争议完全是基于您之委托，不保证争议处理结果符合您的期望，亦不对争议处理结果承担任何责任。
    </p>
    <p>
      <b>7.5 网络公布：</b>经生效法律文书确认用户存在违法或违反本协议行为或者智筑通自行判断用户涉嫌存在违法或违反本协议行为的，智筑通有权在智筑通上以网络发布形式公布用户的违法行为并对该用户在智筑通的权限做出相应的限制（包括但不限于限制权利、终止智筑通平台服务等）。
    </p>

    <h1>第八条 许可使用权</h1>
    <p>
      <b>8.1 您完全理解并同意不可撤销地授予智筑通及其关联公司下列权利：</b>
    </p>
    <p>
      8.1.1
      您授予智筑通及其关联公司独家的、全球通用的、永久的、免费的许可使用权利(并有权在多个层面对该权利进行再授权)，使智筑通及其关联公司有权(全部或部分地)使用、复制、修订、改写、发布、翻译、分发、执行和展示用户的全部数据资料（包括但不限于“您的资料”、交易行为数据及全部展示于网站的各类信息）或制作其派生作品，和/或以现在已知或日后开发的任何形式、媒体或技术，将其纳入其他作品内。
    </p>
    <p>
      8.1.2
      您了解并确认，一旦您自愿在智筑通提交、披露第8.1.1条所述的资料，该等资料即可能被其他人士获取和使用。
    </p>
    <p>
      8.1.3
      当您违反本协议或与智筑通签订的其他协议，智筑通有权采取包括但不限于资金强制划转等在内的任何措施，并可中止或终止对您提供部分或全部智筑通平台服务，且通过一定途径公示您的违约情况。智筑通无须就此限制措施或公示行为向您承担任何责任。
    </p>

    <h1>第九条 责任限制、赔偿及补救措施</h1>
    <p>
      <b>9.1 责任限制：</b>
    </p>
    <p>
      9.1.1
      您明确理解和同意，智筑通不对下述任一情况产生的任何损害承担赔偿责任，包括但不限于利润、商誉、使用、数据等方面的损失或其他无形损失(无论智筑通是否已被告知该等损害赔偿的可能性)：
    </p>
    <p>(i) 使用或未能使用智筑通平台服务；</p>
    <p>
      (ii)
      因通过智筑通平台购买或获取任何货物、样品、数据、资料或服务，或通过智筑通平台接收任何信息或缔结任何交易所产生的获取替代货物和服务的费用；
    </p>
    <p>(iii) 未经批准接入或更改您的传输资料或数据；</p>
    <p>(iv) 任何第三方对智筑通平台服务的声明或行为；</p>
    <p>(v) 因任何原因而引起的与智筑通平台服务有关的任何其他事宜，包括疏忽。</p>
    <p>
      9.1.2
      智筑通不能随时预见到任何技术上的问题或其他困难，该等困难可能会导致数据损失或其他服务中断。为此，您明确理解和同意，您使用智筑通平台服务的风险由您自行承担，且智筑通平台服务以“按现状”和“按可得到”的状态提供。智筑通明确声明不作任何种类的明示或暗示的保证，包括但不限于时效性、适用于某一特定用途和无侵权行为等方面的保证。智筑通对下述内容不作保证：
    </p>
    <p>(i) 智筑通平台服务会符合您的要求；</p>
    <p>(ii) 智筑通平台服务不会中断，且适时、安全和不带任何错误；</p>
    <p>(iii) 通过使用智筑通平台服务而可能获取的结果将是准确或可信赖的；</p>
    <p>
      (iv)
      您通过智筑通平台而购买或获取的任何产品、服务、资料或其他材料的质量将符合您的预期。通过使用智筑通平台服务而下载或以其他形式获取任何材料是由您自行全权决定进行的，且与此有关的风险由您自行承担，对于因您下载任何该等材料而发生的您的电脑系统的任何损毁或任何数据损失，您将自行承担责任。您从智筑通平台或通过智筑通平台服务获取的任何口头或书面意见或资料，均不构成未在本协议内明确载明的任何保证责任。
    </p>
    <p>
      <b>9.2 补救措施：</b>在不限制其他补救措施的前提下，发生下述任一情况，智筑通可立即发出警告，暂时中止、永久中止或终止您的会员资格，删除您的任何现有产品信息，以及您在网站上展示的任何其他资料：
    </p>
    <p>(i) 您违反本协议；</p>
    <p>(ii) 智筑通无法核实或鉴定您向智筑通提供的任何资料；</p>
    <p>
      (iii)
      智筑通相信您的行为可能会使您与其他用户或通过智筑通向智筑通提供服务的第三方供应商发生任何争议纠纷，从而产生法律责任。在不限制任何其他补救措施的前提下，若发现您通过智筑通从事涉及诈骗的活动，智筑通可暂停或终止您的账户。
    </p>

    <h1>第十条 其他</h1>
    <p>
      <b>8.1 法律适用：</b>本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律。
    </p>
    <p>
      <b>8.2 可分性：</b>本协议任一条款被视为废止、无效或不可执行，该条款应视为可分的且不影响本协议其余条款的有效性及可执行性。
    </p>
    <p>
      <b>8.3 转让：</b>您同意智筑通因经营业务需要有权将本协议项下的权利义务就部分或全部进行转让，而无须再通知予您并取得您的同意。
    </p>
    <p>
      <b>8.4 争议解决：</b>因本协议或智筑通服务所引起或与其有关的任何争议应向上海西兰蒂亚科技有限公司所在地人民法院提起诉讼。
    </p>
    <p><b>8.5 生效：</b>本协议自您成功注册为智筑通用户之日起生效。</p>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.registrationAgreement {
  max-width: 1200px;
  margin: 0 auto;
  padding: 50px 0 80px;
  p {
    font-size: 16px;
    line-height: 2.5;
  }
  h1 {
    font-size: 24px;
    line-height: 3;
  }
  .underline {
    text-decoration: underline;
  }
}
</style>
